import styled from 'styled-components'
import {
	FixedBottomButtonContainer,
	ScreenContainer as BaseScreenContainer,
	BackButton as BaseBackButton
} from '../styled'

export const ScreenContainer = styled(BaseScreenContainer).attrs({
	$fullHeight: true,
	$gap: '24px',
	$mobileAlignItems: 'flex-start',
	$mobilePadding: '40px 10px 10px 20px'
})``

export const NextButtonContainer = styled(FixedBottomButtonContainer)`
	margin-top: 24px;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		margin-top: 0;
	}
`

export const BackButton = styled(BaseBackButton).attrs({
	$gap: '8px'
})``

